<template>
  <div class="deprecated-root" :style="{ paddingTop: barHeight + 'px', ...cssVars() }">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" @click-left="closeWeb" />
        <span class="tit-left">{{ $t('lang.BaseCommon.k022') }}</span>
      </template>
    </van-nav-bar>
    <!-- 废弃页面 统一提示升级 -->
    <div class="main">
      <p>{{ $t('lang.Deprecated.k001') }}</p>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {}
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>
<style lang="scss" scoped>
.deprecated-root {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  .van-bar {
    ::v-deep .van-nav-bar__left .tit-left {
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-900);
      line-height: var(--lh-title-24);
      color: #333333;
    }
  }
  .main {
    width: 100%;
    p {
      width: 80%;
      margin: 30vh auto 0;
      text-align: center;
      color: #333333;
      font-family: var(--number-font);
      font-size: var(--fs-16);
      line-height: var(--lh-title-24);
    }
  }
}
</style>
